export const DEFAULT_DATA_ACCOUNT = {
  company_name: '',
  tradename: '',
  email: '',
  phone: '',
  fiscalName: '',
  business_type: '',
};
